import React from 'react';

const IncludeTeamIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-include-team" />
    </div>
  );
};

export default IncludeTeamIcon;
